import { createApi } from "@reduxjs/toolkit/dist/query/react";

import { getAbcEconomicLogicLorenzeCurve } from "./analytics/abc_analysis_lorenz_curve";
import { getAbcEconomicLogicPies } from "./analytics/abc_analysis_pie_data";
import { getAbcEconomicLogicTable } from "./analytics/abc_analysis_table";
import { getAbcEconomicLogicTopProducts } from "./analytics/abc_analysis_top_products";
import { getAbcEconomicLogicWidgets } from "./analytics/abc_analysis_widgets";
import { getAdvertAutoToPup, postAdvertAutoToPup } from "./analytics/advert-autotopup";
import { getAdvertAutoToPupSetting } from "./analytics/advert-autotopup/advert_id";
import { getAdvertsByDates } from "./analytics/advert_adverts_by_dates";
import { getAdvertsContentCardBrands } from "./analytics/advert_content_card_brands";
import { getAdvertsContentCardCategories } from "./analytics/advert_content_card_categories";
import { getAdvertsContentCardProductIds } from "./analytics/advert_content_card_product_ids";
import { getAdvertsContentCardSubjects } from "./analytics/advert_content_card_subjects";
import { getAdvertsContentCardSupplierArticle } from "./analytics/advert_content_card_supplier_articles";
import { getAnalyticsAdvertDynamic } from "./analytics/advert_dynamic";
import { getAnalyticsAdvertDynamicGMRelated } from "./analytics/advert_dynamic/gm_related";
import { getHeatMapAsTable } from "./analytics/advert_heat_map/as_table";
import { getAdvertHistory } from "./analytics/advert_history";
import { getAdvertKeywordsByKeywordsTable } from "./analytics/advert_keywords_by_keywords";
import { getAdvertTable } from "./analytics/advert_table";
import { getAnaliticsAdvertTableProductCostNullBarcodes } from "./analytics/advert_table/product_cost_null_barcodes";
import { getAdvertTop } from "./analytics/advert_top";
import { getAdvertWidgets } from "./analytics/advert_widgets";
import { getCostsByZoneDynamic } from "./analytics/advert_zone_costs";
import { getAnalyticsAdverts } from "./analytics/adverts";
import { getAdvertsUpdateList, postAdvertsUpdateList } from "./analytics/adverts/update_list.js";
import { getAnalyticsBarcodesSearch } from "./analytics/barcodes/search";
import { getAnalyticsBrandsByContent } from "./analytics/brands/by-content";
import { getAnalyticsBrandsByRRDates } from "./analytics/brands/by-rr-dates";
import {
  getCabinetAdvertSettings,
  postCabinetAdvertSettings,
} from "./analytics/cabinet-advert-settings";
import { getCabinetBalances } from "./analytics/cabinet_balances";
import { getUpdateCabinetBalances } from "./analytics/cabinet_balances/update";
import { getCapitalizationDynamic } from "./analytics/capitalization_dynamic";
import { getAnalyticsCapitalizationTable } from "./analytics/capitalization_table";
import {
  deleteCartKillerRule,
  getCartKillerRules,
  patchUpdateCartKillerRuleStatus,
  postCreateCartKillerRule,
  putUpdateCartKillerRule,
} from "./analytics/cart-killer";
import { getCartKillerBrands } from "./analytics/cart-killer/brands";
import { getCartKillerDaily } from "./analytics/cart-killer/daily";
import { getCartKillerHistory } from "./analytics/cart-killer/history";
import { getCartKillerProducts } from "./analytics/cart-killer/products";
import { getCartKillerSubjects } from "./analytics/cart-killer/subjects";
import { getCartKillerWidgets } from "./analytics/cart-killer/widgets";
import { getAnalyticsCategories } from "./analytics/categories";
import { getAnalyticsCategoriesByContent } from "./analytics/categories/by-content";
import { getAnalyticsCategoriesByRRDates } from "./analytics/categories/by-rr-dates";
import { getCommissionsAndDiscountsByCategories } from "./analytics/commission_discount_by_categories";
import { getCommissionTopProducts } from "./analytics/commission_discount_top";
import { getCommissionDiscountTopDetails } from "./analytics/commission_discount_top_details";
import { getAnaliticsCommissionDynamicV2 } from "./analytics/commission_dynamic_v2";
import { getCommissionsAndDiscountsTable } from "./analytics/commission_table";
import { getCommissionsAndDiscountsWidgetsV2 } from "./analytics/commission_widgets_v2";
import { getABCAnalyzeCrossMP } from "./analytics/cross-mp/abc_analyze";
import { getABCWidgetsCrossMp } from "./analytics/cross-mp/abc_widgets";
import { getProductCardPromotionDynamic } from "./analytics/cross-mp/advert_dynamic"; //DEPRECATED
import { getProductCardHeatMap } from "./analytics/cross-mp/advert_heat_map";
import { getAdvertsCrossMp } from "./analytics/cross-mp/advert_selector"; //DEPRECATED
import { getProductCardPromotionWidgets } from "./analytics/cross-mp/advert_widgets"; //DEPRECATED
import { getAnalyticsCrossMPBarcodes } from "./analytics/cross-mp/barcodes";
import { getAnalyticsCrossMPBrands } from "./analytics/cross-mp/brands";
import { getProductCardAdvertDetail } from "./analytics/cross-mp/card_advert_detail";
import { getProductCardPromotionHeatMap } from "./analytics/cross-mp/card_advert_heat_map"; //DEPRECATED
import { getProductCardDailyOrdersDynamic } from "./analytics/cross-mp/card_daily_orders";
import { getProductCardIncomingOrdersDynamic } from "./analytics/cross-mp/card_incoming_orders_dynamic"; //DEPRECATED
import { getProductCardIncomingOrdersTable } from "./analytics/cross-mp/card_incoming_orders_table"; //DEPRECATED
import { getProductCardLocalizationOrders } from "./analytics/cross-mp/card_localization_order"; //DEPRECATED
import { getProductCardOrderDetail } from "./analytics/cross-mp/card_order_detail"; //DEPRECATED
import { getProductCardRealizationDetail } from "./analytics/cross-mp/card_realization_detail";
import { getProductCardStatsDetail } from "./analytics/cross-mp/card_stats_detail"; //DEPRECATED
import { getProductCardStockDynamic } from "./analytics/cross-mp/card_stock_dynamic";
import { getProductCardDynamicOfChanges } from "./analytics/cross-mp/card_stock_price_dynamic";
import { getProductCardStockStateTable } from "./analytics/cross-mp/card_stock_state_table";
import { getCostSelectorItemsCrossMP } from "./analytics/cross-mp/cost_selector";
import { getItemAdvertAnalyticsCrossMP } from "./analytics/cross-mp/dynamic/advert_analytics";
import { getItemStatisticsCrossMP } from "./analytics/cross-mp/dynamic/statistics";
import { getItemStatisticsInSizeCrossMP } from "./analytics/cross-mp/dynamic/statistics/in_size";
import { getItemStatisticsWarehouseCrossMP } from "./analytics/cross-mp/dynamic/statistics/warehouse";
import {
  deleteExpenseCrossMPById,
  getExpenseCrossMPById,
  getExpensesCrossMP,
  postCreateExpenseCrossMP,
  putEditExpenseCrossMPById,
} from "./analytics/cross-mp/expense";
import {
  deleteExpenseCategoryCrossMPById,
  getExpenseCategoriesCrossMP,
  getExpenseCategoryCrossMPById,
  postCreateExpenseCategoryCrossMP,
  putEditExpenseCategoryCrossMPById,
} from "./analytics/cross-mp/expense/category";
import {
  deleteExpenseCounterpartyCrossMPById,
  getExpenseCounterpartiesCrossMP,
  getExpenseCounterpartyCrossMPById,
  postCreateExpenseCounterpartyCrossMP,
  putEditExpenseCounterpartyCrossMPById,
} from "./analytics/cross-mp/expense/counterparty";
import { getExpensesCrossMPExport } from "./analytics/cross-mp/expense/export";
import {
  deleteExpenseGroupCrossMPById,
  getExpenseGroupsCrossMP,
  postCreateExpenseGroupCrossMP,
  putEditExpenseGroupCrossMPById,
} from "./analytics/cross-mp/expense/group";
import { getExpensesTemplateCrossMPExport } from "./analytics/cross-mp/expense/group/export";
import { postUploadExpensesTemplateCrossMP } from "./analytics/cross-mp/expense/group/upload_expense";
import { getPredictGMDynamic } from "./analytics/cross-mp/gross_margin_dynamic";
import {
  getIncomeTerms,
  postIncomeTermsInBulk,
  postUploadIncomeTerms,
} from "./analytics/cross-mp/income_terms";
import { getIncomeTermsExport } from "./analytics/cross-mp/income_terms/export";
import { getProductCardLocalizationOrder } from "./analytics/cross-mp/localization";
import { getItemsCrossMP } from "./analytics/cross-mp/mp_items";
import { getAnalyticsCrossMPOrders } from "./analytics/cross-mp/orders";
import { getAnalyticsCrossMPOrdersWidget } from "./analytics/cross-mp/orders_widget";
import { getOverviewAdvertDynamic } from "./analytics/cross-mp/overview_advert_dynamic";
import { getOverviewCostStructureDynamic } from "./analytics/cross-mp/overview_cost_structure_dynamic";
import { getOverviewOrdersDynamic } from "./analytics/cross-mp/overview_orders_dynamic";
import { getOverviewStockTable } from "./analytics/cross-mp/overview_stock";
import { getOverviewTable } from "./analytics/cross-mp/overview_table";
import { getProductCardPostingDynamic } from "./analytics/cross-mp/posting_dynamic";
import { getAnalyticsCrossMPProductCostsIncome } from "./analytics/cross-mp/product_cost_income";
import { getAnalyticsCrossMPProductCostsIncomeDate } from "./analytics/cross-mp/product_cost_income/income_date";
import { uploadIncomeCostCrossMP } from "./analytics/cross-mp/product_cost_income/upload_income_cost";
import { getAnalyticsCrossMPProductCostsV3 } from "./analytics/cross-mp/product_cost_v3";
import { uploadDefaultCostCrossMP } from "./analytics/cross-mp/product_cost_v3/upload_default_cost";
import { getProductCrossMp } from "./analytics/cross-mp/products";
import { getProductCardDetail } from "./analytics/cross-mp/products_card_detail"; //DEPRECATED
import { getProductCardRealizationWidgets } from "./analytics/cross-mp/realization_widgets"; //DEPRECATED
import { getProductCardFunnelWidgets } from "./analytics/cross-mp/sales_pipeline_widgets"; //DEPRECATED
import { getAnalyticsCrossMPSubjects } from "./analytics/cross-mp/subjects";
import { getWarehouseByOrder } from "./analytics/cross-mp/warehouse_by_order";
import { getDeductionDetailization } from "./analytics/deduction_detalization";
import { getEvents } from "./analytics/events";
import { getAnalyticsForecastingAdditionalDeliveries } from "./analytics/forecasting/additional_deliveries";
import { getAnalyticsForecastingAdditionalDeliveryItems } from "./analytics/forecasting/additional_delivery_items";
import { getSupplyDistributionLogisticTable } from "./analytics/forecasting/tariffs_and_wh_times_table";
import { getSupplyDistributionLogisticTableExport } from "./analytics/forecasting/tariffs_and_wh_times_table/export";
import { getLocalizationIndex } from "./analytics/forecasting/warehouse_supply_distribution_localization_index";
import { getWarehouseSupplyDistributionSummary } from "./analytics/forecasting/warehouse_supply_distribution_summary_by_regions";
import { getWarehouseSupplyDistributionTable } from "./analytics/forecasting/warehouse_supply_distribution_table";
import { getWarehouseSupplyDistributionTableExport } from "./analytics/forecasting/warehouse_supply_distribution_table/export";
import { getWarehousesSupplyDynamic } from "./analytics/forecasting/warehouse_supply_dynamic";
import { getWarehousesSupplyTable } from "./analytics/forecasting/warehouse_supply_table";
import { getWarehousesSupplyTableExport } from "./analytics/forecasting/warehouse_supply_table/export";
import { getWarehousesSupplyWidgets } from "./analytics/forecasting/warehouse_supply_widgets";
import { getGlobalEvents } from "./analytics/global_events";
import {
  addAnalyticsGluing,
  deleteAnalyticsGluing,
  getAnalyticsGluing,
  getAnalyticsGluingActive,
  getAnalyticsGluingProducts,
} from "./analytics/gluing";
import {
  getAnalyticsKeyIndicatorsDynamic,
  getKeyIndicatorsDynamic,
} from "./analytics/key_indicators_dynamic";
import { getKeyIndicatorsTable } from "./analytics/key_indicators_table";
import { getKeyIndicatorsWBServicesStructure } from "./analytics/key_indicators_wb_services_structure";
import { getKeyIndicatorsWidgets } from "./analytics/key_indicators_widgets";
import { getNotificationGroups } from "./analytics/notification-groups";
import { getNotificationSubscription } from "./analytics/notification-subscriptions";
import { getOrderAndSales } from "./analytics/order_and_sales";
import { getPaidStorageBarcodes } from "./analytics/paid_storage_barcodes";
import { getPaidStorageBrands } from "./analytics/paid_storage_brands";
import { getStorageAndAcceptanceDiagram } from "./analytics/paid_storage_dynamic";
import { getStorageAndAcceptanceOfficesCircle } from "./analytics/paid_storage_offices";
import { getPaidStorageProductId } from "./analytics/paid_storage_product_id";
import { getPaidStorageSubjects } from "./analytics/paid_storage_subject";
import { getPaidStorageSupplierArticle } from "./analytics/paid_storage_supplier_article";
import { getStorageAndAcceptanceTable } from "./analytics/paid_storage_table";
import { getStorageAndAcceptanceTopProducts } from "./analytics/paid_storage_top_products";
import { getStorageAndAcceptanceWarehouseCoefsCircles } from "./analytics/paid_storage_warehouse_coefs";
import { getStorageAndAcceptanceWarehouseCoefsTable } from "./analytics/paid_storage_warehouse_coefs_table";
import { getStorageAndAcceptanceWarehouseDetailsTable } from "./analytics/paid_storage_warehouse_detalization_table";
import { getStorageAndAcceptanceWidgets } from "./analytics/paid_storage_widgets";
import { getFinesAndCompensationDynamic } from "./analytics/penalty_additionals_dynamic";
import { getFinesAndCompensationOffices } from "./analytics/penalty_additionals_offices";
import { getFinesAndCompensationTypes } from "./analytics/penalty_additionals_penalty_types";
import { getFinesAndCompensationTypesProducts } from "./analytics/penalty_additionals_penalty_types_products";
import { getFinesAndCompensationTable } from "./analytics/penalty_additionals_table";
import { getFinesAndCompensationTopProducts } from "./analytics/penalty_additionals_top_products";
import { getFinesAndCompensationWidgets } from "./analytics/penalty_additionals_widgets";
import { getSppAnalyticsPrices } from "./analytics/prices";
import { getAnalyticsPricesSubjects } from "./analytics/prices/subjects";
import { postProductCost } from "./analytics/product_cost";
import { getAnalyticsProductCostV2 } from "./analytics/product_cost_v2";
import { postProductCostValidator } from "./analytics/product_cost_validator";
import { getAnalyticsProductSizes } from "./analytics/product_size";
import { getAnalyticsProductsForSelectorsAdvert } from "./analytics/products-for-selectors/advert";
import { getAnalyticsProductsForSelectorsPaidStorage } from "./analytics/products-for-selectors/paid-storage";
import { getAnalyticsProductsForSelectorsRR } from "./analytics/products-for-selectors/rr";
import { getAnalyticsProductsGluing } from "./analytics/products_gluing";
import { getAnalyticsProductsJoint } from "./analytics/products_joint/";
import { getAnalyticsProductsSearch } from "./analytics/products_search/";
import { getAnalyticsProductsSearchFunnel } from "./analytics/products_search_funnel";
import { getPromotions } from "./analytics/promotion";
import { getPromotionsProducts } from "./analytics/promotion/promotion_product";
import { getRefundsAndTransfersDiagram } from "./analytics/ride_returns_dynamic";
import { getRefundsAndTransfersOffices } from "./analytics/ride_returns_offices";
import { getRefundsAndTransfersTables } from "./analytics/ride_returns_table";
import { getRefundsAndTransfersTopProduct } from "./analytics/ride_returns_top_products";
import { getRefundsAndTransfersWidgets } from "./analytics/ride_returns_widgets";
import { getSettings } from "./analytics/settings";
import { getSettingsNds } from "./analytics/settings_nds";
import { postCreateShares } from "./analytics/shares";
import { putShares } from "./analytics/shares";
import { patchAnalyticsSharesById } from "./analytics/shares";
import { managementProductsInShares } from "./analytics/shares/product_management";
import { getSharesProductArticle } from "./analytics/shares/products_article";
import { getSharesProductCategories } from "./analytics/shares/products_category";
import { getSharesProductSubjects } from "./analytics/shares/products_subject";
import { getShareById } from "./analytics/shares/share_by_id";
import {
  deleteSharesLevel,
  postSharesLevel,
  putSharesLevels,
} from "./analytics/shares/shares_level";
import { getSharesList } from "./analytics/shares/shares_list";
import { postSharesUpload } from "./analytics/shares/shares_upload";
import { getSharesProductsHistory } from "./analytics/shares_log";
import { getSharesProductsHistoryExport } from "./analytics/shares_log/export";
import { postProductsPriceAndDiccont } from "./analytics/shares_products";
import { getProductCostCheck } from "./analytics/shares_products/cost_check";
import { getProductCostInfo } from "./analytics/shares_products/cost_info";
import { postDownloadCostExample } from "./analytics/shares_products/export";
import { getProductsPriceAndDiccont } from "./analytics/shares_products/index";
import { postUploadCost } from "./analytics/shares_products/upload_cost";
import { postPromotionsProductsUpload } from "./analytics/shares_products/upload_excel";
import { getSharesSummary } from "./analytics/shares_summary";
import { getSharesTable } from "./analytics/shares_table";
import { getSharesTableExport } from "./analytics/shares_table/export";
import { getSharesTableProductCounts } from "./analytics/shares_table/product_status";
import { getSharesTableWbExport } from "./analytics/shares_table/wb/export";
import { getAnalyticsSubjectsByContent } from "./analytics/subjects/by-content";
import { getAnalyticsSubjectsByRRDates } from "./analytics/subjects/by-rr-dates";
import { getTaxRates } from "./analytics/tax_rates";
import { getAnalyticsTextSearchFunnel } from "./analytics/text_search_funnel";
import { getTop10Products } from "./analytics/top_ten_products";
import { getAnalyticsTradeEconomyDynamic } from "./analytics/trade_economy_dynamic";
import { getTradeEconomyTable } from "./analytics/trade_economy_table";
import { getTradeEconomyWidgets } from "./analytics/trade_economy_widgets";
import { getUnitEconomyTable } from "./analytics/unit_economy_table";
import { getUnitEconomyTableExport } from "./analytics/unit_economy_table/export";
import {
  getCalcOptionsWarehouses,
  postCalcOptionsWarehouses,
} from "./analytics/wh_supply/calc_options";
import {
  getOwnStock,
  postDeleteOwnStock,
  postUploadOwnStock,
} from "./analytics/wh_supply/own_stock";
import {
  deletePlannedStockBySupplyId,
  getPlannedStock,
  getPlannedStockBySupplyId,
  postUploadPlannedStock,
} from "./analytics/wh_supply/planned_stock";
import { getRegionClusters } from "./analytics/wh_supply/region-clusters";
import {
  postSplitToSupplies,
  postSplitToSuppliesByDate,
} from "./analytics/wh_supply/split_to_supplies";
import {
  postSplitToSuppliesExportByWarehouse,
  postSplitToSuppliesExportTable,
} from "./analytics/wh_supply/split_to_supplies/export";
import { postSplitToSuppliesExportArchive } from "./analytics/wh_supply/split_to_supplies/export_archive";
import { getAvailableSupplyDates } from "./analytics/wh_supply/split_to_supplies/supply_dates";
import { getTransitWarehouses } from "./analytics/wh_supply/transit_warehouses";
import { getMPCabinets } from "./company/mp_cabinets";
import { getTokensByCabinetId } from "./company/mp_cabinets";
import { postSyncTypes } from "./company/mp_cabinets/syncJam";
import { getCompanyPurchaseHistory } from "./company/purchase_history";
import { postCompanyV2PurchaseCalc } from "./company/v2/purchase_calc";
import { getWBCabinets } from "./company/wb_cabinets";
import { getWBtokens } from "./company/wb_cabinets/tokens";
import { getMarksBrands } from "./monitoring/marks/brands";
import { getMarksCategories } from "./monitoring/marks/categories";
import { getMarksProducts } from "./monitoring/marks/products";
import { getMarksSellers } from "./monitoring/marks/sellers";
import { getParsersKeywords } from "./monitoring/position_in_search/parsersKeywords";
import { getSppLimitsMonitoring } from "./monitoring/spp_user_notification/limits";
import { updateMonitoringTraffics } from "./monitoring/supplier_article_advert_monitoring/bulk_update";
import { getWbUserDisabledNotifications } from "./monitoring/wb_user_disabled_notification";
import { postWbUserDisabledNotifications } from "./monitoring/wb_user_disabled_notification";
import { GetMoySkladTokenById } from "./moysklad/tokens";
import { getAbcLorenzeCurveOzon } from "./ozon_analytics/abc_analysis/lorenz_curve";
import { getAbcPiesOzon } from "./ozon_analytics/abc_analysis/pie_data";
import { getAbcTableOzon } from "./ozon_analytics/abc_analysis/table";
import { abcTableOzonDownload } from "./ozon_analytics/abc_analysis/table/export";
import { getAbcTopProductsOzon } from "./ozon_analytics/abc_analysis/top_products";
import { getAbcAnalysisWidgetsOzon } from "./ozon_analytics/abc_analysis/widgets";
import { getAdvertCampaignsOzon } from "./ozon_analytics/advert_campaigns";
import { getAdvertDynamicOzon } from "./ozon_analytics/advert_dynamic";
import { getAdvertSearchPromoTableOzon } from "./ozon_analytics/advert_search_promo_table";
import { advertSearchPromoTableOzonDownload } from "./ozon_analytics/advert_search_promo_table/export";
import { getAdvertSkuTableOzon } from "./ozon_analytics/advert_sku_table";
import { advertSkuTableOzonDownload } from "./ozon_analytics/advert_sku_table/export";
import { getAdvertTopBlockOzon } from "./ozon_analytics/advert_top";
import { getAdvertWidgetsOzon } from "./ozon_analytics/advert_widgets";
import { getAnalyticsCrossMPProductCostsOzon } from "./ozon_analytics/income_product_cost";
import { getAnalyticsCrossMPProductCostsIncomeDateOzon } from "./ozon_analytics/income_product_cost/income_dates";
import { getPostingCancellationDiagramInitiatorOzon } from "./ozon_analytics/posting_cancellation/diagram/initiator";
import { getPostingCancellationDiagramReasonOzon } from "./ozon_analytics/posting_cancellation/diagram/reason";
import { getPostingCancellationDiagramTopTenOzon } from "./ozon_analytics/posting_cancellation/diagram/top_ten";
import { getPostingCancellationDiagramWarehouseOzon } from "./ozon_analytics/posting_cancellation/diagram/warehouse";
import { getPostingCancellationDiagramDynamicOzon } from "./ozon_analytics/posting_cancellation_dynamic";
import { getCancellationTableOzon } from "./ozon_analytics/posting_cancellation_table";
import { getPostingCancellationWidgetsOzon } from "./ozon_analytics/posting_cancellation_widgets";
import { getPostingEconomyDiagramOzon } from "./ozon_analytics/posting_economy_diagram";
import { getEconomyOfShipmentsDynamicOzon } from "./ozon_analytics/posting_economy_dynamic";
import { getEconomyOfShipmentsOzonTable } from "./ozon_analytics/posting_economy_table";
import { getPostingEconomyWidgetsOzon } from "./ozon_analytics/posting_economy_widgets";
import { getPostingReturnDiagramReasonOzon } from "./ozon_analytics/posting_return/diagram/reason";
import { getPostingReturnDiagramTopTenOzon } from "./ozon_analytics/posting_return/diagram/top_ten";
import { getPostingReturnDiagramWarehouseOzon } from "./ozon_analytics/posting_return/diagram/warehouse";
import { getPostingReturnsDiagramDynamicOzon } from "./ozon_analytics/posting_return_dynamic";
import { getReturnTableOzon } from "./ozon_analytics/posting_return_table";
import { getPostingReturnWidgetsOzon } from "./ozon_analytics/posting_return_widgets";
import { getUnitEconomyMultiTableOzon } from "./ozon_analytics/unit_economy_multi_table";
import { unitEconomyMultiTableOzonDownload } from "./ozon_analytics/unit_economy_multi_table/export";
import { getUnitEconomySingleTableOzon } from "./ozon_analytics/unit_economy_single_table";
import { unitEconomySingleTableOzonDownload } from "./ozon_analytics/unit_economy_single_table/export";
import { getParsersBrands } from "./parsers/brands";
import { getParsersCollectionsKeywords } from "./parsers/collections/keywords";
import { getParsersCollectionsKeywordsById } from "./parsers/collections/keywords/byId";
import { getParsersCollectionsProducts } from "./parsers/collections/products";
import { getParsersCollectionsProductsById } from "./parsers/collections/products/byId";
import { getParsersCompanyFinances } from "./parsers/company_finances";
import { getParsersCompanyFinancesLimits } from "./parsers/company_finances/limits";
import { getKeywordsPosition, getParsersKeywordsPosition } from "./parsers/keywords-position";
import { getKeywordsPositionData } from "./parsers/keywords-position/data";
import { exportKeywordsPositionRunId } from "./parsers/keywords-position/export";
import { getKeywordsPositionLimits } from "./parsers/keywords-position/limits";
import { postKeywordsPositionReloadRun } from "./parsers/keywords-position/reload_run";
import { postKeywordsPositionRunDelete } from "./parsers/keywords-position/run_delete";
import { getKeywordsPositionRunId } from "./parsers/keywords-position/run_id";
import { getParserKeywordsClusterGroups } from "./parsers/keywords_cluster/groups";
import { getParserKeywordsClusterGroupsV2 } from "./parsers/keywords_cluster/groups_v2";
import { postParserKeywordsClusterGroupsV2 } from "./parsers/keywords_cluster/groups_v2";
import { getSocialBloggers } from "./parsers/social/bloggers";
import { getBloggerCard } from "./parsers/social/bloggers/blogger_card";
import { getSocialBloggersBloggers } from "./parsers/social/bloggers/bloggers";
import { getSocialBloggersBrands } from "./parsers/social/bloggers/brands";
import { getSocialBloggersCount } from "./parsers/social/bloggers/count";
import { getSocialBloggersProducts } from "./parsers/social/bloggers/products";
import { getSocialBloggersRating } from "./parsers/social/bloggers/rating";
import { getSocialBloggersSimilar } from "./parsers/social/bloggers/similar";
import { getSocialBloggersSimilarExport } from "./parsers/social/bloggers/similar_export";
import { getSocialBloggersSubjects } from "./parsers/social/bloggers/subjects";
import { getParsersSocialPosts } from "./parsers/social/posts";
import { getBloggersPostsSelectionBloggers } from "./parsers/social/posts/bloggers";
import { getBloggersPostsSelectionBrands } from "./parsers/social/posts/brands";
import { getParsersSocialPostsCount } from "./parsers/social/posts/count";
import { getParsersSocialPostsProducts } from "./parsers/social/posts/products";
import { getParsersSocialPostsSubjects } from "./parsers/social/posts/subjects";
import { getSocialRating } from "./parsers/social/rating";
import { getBloggerSubjects } from "./parsers/social/subject";
import { getBloggerSubjectsGrouped } from "./parsers/social/subject";
import { getParsersSubjects } from "./parsers/subjects";
import { getSubjectById } from "./parsers/subjects/id";
import { getParsersSupplierArticleAdvertsLimits } from "./parsers/supplier_article_adverts/limits";
import { getParsersSupplierArticleAdvertsUsageHistory } from "./parsers/supplier_article_adverts/usage_history";
import { getPromoPartners } from "./promo_partners";
import { getPromoPartnerInfo } from "./promo_partners/id";
import { getSPPUserNotification } from "./spp/monitoring";
import { getSPPList } from "./spp/monitoring";
import { getTariffPlans } from "./tariff/plans";
import { getWBDynamicBrandColors } from "./wb_dynamic/brand_colors";
import { getWBDynamicBrandsSummary } from "./wb_dynamic/brands_summary";
import { getWBDynamicBrandsSummaryCount } from "./wb_dynamic/brands_summary/count";
import { getBrandsTrend } from "./wb_dynamic/brands_trend";
import { getWBDynamicBrandsTrendGrouped } from "./wb_dynamic/brands_trend/grouped";
import { getWBDynamicCategoriesSummary } from "./wb_dynamic/categories_summary";
import { getWBDynamicCategoriesSummaryCount } from "./wb_dynamic/categories_summary/count";
import { getCategoriesTrend } from "./wb_dynamic/categories_trend";
import { getCategoriesTrendGrouped } from "./wb_dynamic/categories_trend/grouped";
import { getWBDynamicGeneralCategories } from "./wb_dynamic/general_categories";
import { getKeywordPredict } from "./wb_dynamic/keyword_predict";
import { getWBDynamicKeywordsIds } from "./wb_dynamic/keywords_ids";
import { getWBDynamicKeywordsStat } from "./wb_dynamic/keywords_stat";
import { getWBDynamicKeywordsStatByIDDailyDynamic } from "./wb_dynamic/keywords_stat/byId/daily_dynamic";
import { getWBDynamicKeywordsStatByIDMonthlyDynamic } from "./wb_dynamic/keywords_stat/byId/monthly_dynamic";
import { getWBDynamicKeywordsStatByIDWeeklyDynamic } from "./wb_dynamic/keywords_stat/byId/weekly_dynamic";
import { getKeywordsSummaryV2 } from "./wb_dynamic/keywords_summary_v2";
import { getKeywordsSummaryV2Count } from "./wb_dynamic/keywords_summary_v2/count";
import { getKeywordsSummaryV2Subjects } from "./wb_dynamic/keywords_summary_v2/subjects";
import { getWBDynamicProducts } from "./wb_dynamic/products";
import { getProductsDynamicById } from "./wb_dynamic/products/byId";
import { getWBDynamicProductsExport } from "./wb_dynamic/products/export";
import { getWBDynamicProductsGrouped } from "./wb_dynamic/products/grouped";
import { getWBDynamicProductsByIdKeywords } from "./wb_dynamic/products/keywordById";
import { getWBDynamicProductsSummary } from "./wb_dynamic/products_summary";
import { getWBDynamicProductsSummaryCount } from "./wb_dynamic/products_summary/count";
import { getProductsTrend } from "./wb_dynamic/products_trend";
import { getWBDynamicProductsTrendGrouped } from "./wb_dynamic/products_trend/grouped";
import { getWBDynamicSellers } from "./wb_dynamic/sellers";
import { getWBDynamicSellersSummary } from "./wb_dynamic/sellers_summary";
import { getWBDynamicSellersSummaryCount } from "./wb_dynamic/sellers_summary/count";
import { getSellersTrend } from "./wb_dynamic/sellers_trend";
import { getWBDynamicSellersTrendGrouped } from "./wb_dynamic/sellers_trend/grouped";
import { getWBDynamicSubjects } from "./wb_dynamic/subjects";
import { getWBDynamicSubjectsById } from "./wb_dynamic/subjects/id";
import { getWBDynamicWarehouses } from "./wb_dynamic/warehouses";

// - api function list
const apiFunctions = {
  getAbcEconomicLogicLorenzeCurve,
  getAbcEconomicLogicPies,
  getAbcEconomicLogicTable,
  getAbcEconomicLogicTopProducts,
  getAbcEconomicLogicWidgets,
  getAnalyticsAdvertDynamic,
  getAdvertTable,
  getAdvertTop,
  getAdvertWidgets,
  getCostsByZoneDynamic,
  getAdvertsByDates,
  getAdvertsContentCardBrands,
  getAdvertsContentCardCategories,
  getAdvertsContentCardProductIds,
  getAdvertsContentCardSubjects,
  getAdvertsContentCardSupplierArticle,
  getAnalyticsCapitalizationTable,
  getAnalyticsForecastingAdditionalDeliveries,
  getAnalyticsForecastingAdditionalDeliveryItems,
  getAnalyticsProductsForSelectorsAdvert,
  getAnalyticsProductsForSelectorsPaidStorage,
  getHeatMapAsTable,
  getAdvertKeywordsByKeywordsTable,
  getAnaliticsAdvertTableProductCostNullBarcodes,
  getCapitalizationDynamic,
  getAnalyticsCategories,
  getAnalyticsCategoriesByContent,
  getAnalyticsCategoriesByRRDates,
  getCommissionsAndDiscountsTable,
  getCommissionsAndDiscountsByCategories,
  getCommissionTopProducts,
  getCommissionDiscountTopDetails,
  getAnaliticsCommissionDynamicV2,
  getCommissionsAndDiscountsWidgetsV2,
  getABCAnalyzeCrossMP,
  getABCWidgetsCrossMp,
  getProductCardPromotionDynamic,
  getProductCardHeatMap,
  getAdvertsCrossMp,
  getProductCardPromotionWidgets,
  getAnalyticsCrossMPBarcodes,
  getAnalyticsCrossMPBrands,
  getProductCardAdvertDetail,
  getProductCardPromotionHeatMap,
  getProductCardDailyOrdersDynamic,
  getProductCardIncomingOrdersDynamic,
  getProductCardIncomingOrdersTable,
  getProductCardLocalizationOrders,
  getProductCardOrderDetail,
  getProductCardRealizationDetail,
  getProductCardStatsDetail,
  getProductCardStockDynamic,
  getProductCardDynamicOfChanges,
  getProductCardStockStateTable,
  getCostSelectorItemsCrossMP,
  getItemAdvertAnalyticsCrossMP,
  getItemStatisticsCrossMP,
  getItemStatisticsInSizeCrossMP,
  getItemStatisticsWarehouseCrossMP,
  getPredictGMDynamic,
  getProductCardLocalizationOrder,
  getOverviewTable,
  getItemsCrossMP,
  getAnalyticsCrossMPOrders,
  getAnalyticsCrossMPOrdersWidget,
  getOverviewAdvertDynamic,
  getOverviewCostStructureDynamic,
  getOverviewOrdersDynamic,
  getOverviewStockTable,
  getProductCardPostingDynamic,
  getAnalyticsCrossMPProductCostsIncome,
  getAnalyticsCrossMPProductCostsIncomeDate,
  getAnalyticsCrossMPProductCostsV3,
  uploadIncomeCostCrossMP,
  uploadDefaultCostCrossMP,
  getProductCrossMp,
  getProductCardDetail,
  getProductCardRealizationWidgets,
  getProductCardFunnelWidgets,
  getAnalyticsCrossMPSubjects,
  getWarehouseByOrder,
  getEvents,
  getAnalyticsBarcodesSearch,
  getAnalyticsBrandsByContent,
  getAnalyticsBrandsByRRDates,
  getAnalyticsSubjectsByContent,
  getAnalyticsSubjectsByRRDates,
  getTaxRates,
  getAnalyticsProductCostV2,
  getTariffPlans,
  postCompanyV2PurchaseCalc,
  getMPCabinets,
  getTokensByCabinetId,
  postSyncTypes,
  getTop10Products,
  getAnalyticsProductsForSelectorsRR,
  getAnalyticsProductsGluing,
  getAnalyticsProductsJoint,
  getAnalyticsProductsSearch,
  getAnalyticsProductSizes,
  getGlobalEvents,
  addAnalyticsGluing,
  getAnalyticsGluing,
  getAnalyticsGluingActive,
  getAnalyticsGluingProducts,
  deleteAnalyticsGluing,
  getKeyIndicatorsDynamic,
  getSharesProductsHistory,
  getKeyIndicatorsTable,
  getKeyIndicatorsWBServicesStructure,
  getKeyIndicatorsWidgets,
  getDeductionDetailization,
  getNotificationGroups,
  getNotificationSubscription,
  getOrderAndSales,
  getPaidStorageBarcodes,
  getPaidStorageBrands,
  getPaidStorageProductId,
  getPaidStorageSubjects,
  getPaidStorageSupplierArticle,
  getProductsTrend,
  getStorageAndAcceptanceDiagram,
  getStorageAndAcceptanceOfficesCircle,
  getStorageAndAcceptanceTable,
  getStorageAndAcceptanceTopProducts,
  getStorageAndAcceptanceWarehouseCoefsCircles,
  getStorageAndAcceptanceWarehouseCoefsTable,
  getStorageAndAcceptanceWarehouseDetailsTable,
  getStorageAndAcceptanceWidgets,
  getFinesAndCompensationDynamic,
  getFinesAndCompensationOffices,
  getFinesAndCompensationTypes,
  getFinesAndCompensationTypesProducts,
  getFinesAndCompensationTable,
  getFinesAndCompensationTopProducts,
  getFinesAndCompensationWidgets,
  getSppAnalyticsPrices,
  getAnalyticsPricesSubjects,
  getAbcAnalysisWidgetsOzon,
  getAdvertCampaignsOzon,
  getAdvertDynamicOzon,
  getAdvertSearchPromoTableOzon,
  advertSearchPromoTableOzonDownload,
  getAdvertSkuTableOzon,
  advertSkuTableOzonDownload,
  getAdvertTopBlockOzon,
  getAdvertWidgetsOzon,
  getAnalyticsCrossMPProductCostsOzon,
  getAnalyticsCrossMPProductCostsIncomeDateOzon,
  getPostingCancellationDiagramInitiatorOzon,
  getPostingCancellationDiagramReasonOzon,
  getPostingCancellationDiagramTopTenOzon,
  getPostingCancellationDiagramWarehouseOzon,
  getPostingCancellationDiagramDynamicOzon,
  getCancellationTableOzon,
  getPostingCancellationWidgetsOzon,
  getWBCabinets,
  getWBtokens,
  GetMoySkladTokenById,
  getSettings,
  getSettingsNds,
  getEconomyOfShipmentsOzonTable,
  getPostingEconomyDiagramOzon,
  getEconomyOfShipmentsDynamicOzon,
  getPostingEconomyWidgetsOzon,
  getPostingReturnDiagramReasonOzon,
  getPostingReturnDiagramTopTenOzon,
  getPostingReturnDiagramWarehouseOzon,
  getPostingReturnsDiagramDynamicOzon,
  getReturnTableOzon,
  getPostingReturnWidgetsOzon,
  getUnitEconomyMultiTableOzon,
  unitEconomyMultiTableOzonDownload,
  getUnitEconomySingleTableOzon,
  unitEconomySingleTableOzonDownload,
  getAbcLorenzeCurveOzon,
  getAbcPiesOzon,
  getAbcTableOzon,
  abcTableOzonDownload,
  getAbcTopProductsOzon,
  getSocialBloggers,
  getSocialBloggersBloggers,
  getSocialBloggersBrands,
  getSocialBloggersCount,
  getSocialBloggersProducts,
  getSocialBloggersRating,
  getSocialBloggersSubjects,
  getSocialRating,
  getKeywordsSummaryV2,
  getKeywordsSummaryV2Count,
  getKeywordsSummaryV2Subjects,
  getKeywordsPosition,
  getKeywordsPositionData,
  getKeywordsPositionLimits,
  postKeywordsPositionReloadRun,
  getKeywordsPositionRunId,
  exportKeywordsPositionRunId,
  getProductsDynamicById,
  getWBDynamicProductsTrendGrouped,
  getAnalyticsAdverts,
  getAdvertAutoToPup,
  postAdvertAutoToPup,
  getCabinetAdvertSettings,
  postCabinetAdvertSettings,
  getCabinetBalances,
  getUpdateCabinetBalances,
  getAdvertAutoToPupSetting,
  getPromotions,
  getSharesProductCategories,
  postCreateShares,
  getSharesList,
  getShareById,
  getAdvertHistory,
  postUploadCost,
  postDownloadCostExample,
  putShares,
  getPromotionsProducts,
  getRefundsAndTransfersDiagram,
  getRefundsAndTransfersOffices,
  getRefundsAndTransfersTables,
  getRefundsAndTransfersTopProduct,
  getRefundsAndTransfersWidgets,
  deleteSharesLevel,
  postSharesLevel,
  putSharesLevels,
  postPromotionsProductsUpload,
  getSharesTable,
  getSharesProductSubjects,
  getSharesSummary,
  postAdvertsUpdateList,
  getAdvertsUpdateList,
  getUnitEconomyTable,
  getUnitEconomyTableExport,
  getTradeEconomyWidgets,
  getTradeEconomyTable,
  getWarehousesSupplyDynamic,
  getWarehousesSupplyTable,
  getWarehousesSupplyWidgets,
  getCategoriesTrend,
  getBrandsTrend,
  getSellersTrend,
  getMarksBrands,
  getMarksCategories,
  getMarksProducts,
  getMarksSellers,
  postSharesUpload,
  getSharesTableExport,
  getSharesProductArticle,
  getWBDynamicGeneralCategories,
  getKeywordPredict,
  getWBDynamicProductsSummary,
  getWBDynamicProductsSummaryCount,
  getWBDynamicBrandsSummary,
  getWBDynamicBrandsSummaryCount,
  getWBDynamicCategoriesSummary,
  getWBDynamicCategoriesSummaryCount,
  getWBDynamicSellersSummary,
  getWBDynamicSellersSummaryCount,
  getWBDynamicProductsByIdKeywords,
  getWBDynamicWarehouses,
  getWBDynamicBrandColors,
  managementProductsInShares,
  getWBDynamicBrandsTrendGrouped,
  getWBDynamicSellersTrendGrouped,
  getCategoriesTrendGrouped,
  getParsersSupplierArticleAdvertsUsageHistory,
  getAnalyticsKeyIndicatorsDynamic,
  getWBDynamicProducts,
  getParsersSupplierArticleAdvertsLimits,
  getAnalyticsAdvertDynamicGMRelated,
  getWBDynamicKeywordsStat,
  getWBDynamicKeywordsStatByIDDailyDynamic,
  getWBDynamicProductsExport,
  postKeywordsPositionRunDelete,
  getAnalyticsProductsSearchFunnel,
  getAnalyticsTextSearchFunnel,
  getAnalyticsTradeEconomyDynamic,
  getProductCostCheck,
  getProductCostInfo,
  updateMonitoringTraffics,
  getWbUserDisabledNotifications,
  postWbUserDisabledNotifications,
  getParsersKeywords,
  getSppLimitsMonitoring,
  getParsersSocialPostsCount,
  getParsersSocialPosts,
  getParsersSocialPostsProducts,
  getBloggerSubjects,
  getBloggerSubjectsGrouped,
  getWBDynamicProductsGrouped,
  getRegionClusters,
  postCalcOptionsWarehouses,
  getBloggerCard,
  getParsersSocialPostsSubjects,
  getSocialBloggersSimilar,
  getSocialBloggersSimilarExport,
  getWBDynamicKeywordsStatByIDWeeklyDynamic,
  getWBDynamicKeywordsStatByIDMonthlyDynamic,
  getSharesTableWbExport,
  postProductCost,
  postProductCostValidator,
  getCalcOptionsWarehouses,
  getWarehouseSupplyDistributionSummary,
  getWarehouseSupplyDistributionTable,
  getWarehouseSupplyDistributionTableExport,
  getSupplyDistributionLogisticTable,
  getWarehousesSupplyTableExport,
  getSupplyDistributionLogisticTableExport,
  getPromoPartners,
  getSharesTableProductCounts,
  getWBDynamicKeywordsIds,
  getParsersCollectionsKeywords,
  getParsersCollectionsKeywordsById,
  getAvailableSupplyDates,
  postSplitToSupplies,
  getPromoPartnerInfo,
  getProductsPriceAndDiccont,
  getSharesProductsHistoryExport,
  postProductsPriceAndDiccont,
  getParsersSubjects,
  getSubjectById,
  getWBDynamicSubjectsById,
  getSPPUserNotification,
  getSPPList,
  postSplitToSuppliesByDate,
  postUploadPlannedStock,
  getPlannedStock,
  getPlannedStockBySupplyId,
  deletePlannedStockBySupplyId,
  postUploadOwnStock,
  getOwnStock,
  getParserKeywordsClusterGroups,
  getWBDynamicSubjects,
  getParsersCollectionsProducts,
  getParsersCollectionsProductsById,
  patchAnalyticsSharesById,
  getTransitWarehouses,
  getParserKeywordsClusterGroupsV2,
  postParserKeywordsClusterGroupsV2,
  getParsersBrands,
  getParsersKeywordsPosition,
  getExpensesCrossMP,
  getExpenseCrossMPById,
  postCreateExpenseCrossMP,
  putEditExpenseCrossMPById,
  deleteExpenseCrossMPById,
  getExpensesCrossMPExport,
  getExpenseCategoriesCrossMP,
  getExpenseCategoryCrossMPById,
  postCreateExpenseCategoryCrossMP,
  putEditExpenseCategoryCrossMPById,
  deleteExpenseCategoryCrossMPById,
  getExpenseCounterpartiesCrossMP,
  getExpenseCounterpartyCrossMPById,
  postCreateExpenseCounterpartyCrossMP,
  putEditExpenseCounterpartyCrossMPById,
  deleteExpenseCounterpartyCrossMPById,
  getExpenseGroupsCrossMP,
  postCreateExpenseGroupCrossMP,
  putEditExpenseGroupCrossMPById,
  deleteExpenseGroupCrossMPById,
  getExpensesTemplateCrossMPExport,
  postUploadExpensesTemplateCrossMP,
  getCompanyPurchaseHistory,
  getIncomeTerms,
  postIncomeTermsInBulk,
  getLocalizationIndex,
  postSplitToSuppliesExportArchive,
  postDeleteOwnStock,
  postSplitToSuppliesExportByWarehouse,
  postSplitToSuppliesExportTable,
  getIncomeTermsExport,
  postUploadIncomeTerms,
  getWBDynamicSellers,
  getBloggersPostsSelectionBloggers,
  getBloggersPostsSelectionBrands,
  getParsersCompanyFinances,
  getParsersCompanyFinancesLimits,
};

// --------------------------------------------------------------------
export const queryAPI = createApi({
  reducerPath: "queryAPI",
  baseQuery: async ({ apiMethod, params }) => {
    try {
      const data = await apiMethod(params);
      return { data };
    } catch (error) {
      return { error };
    }
  },
  tagTypes: ["UserData"],
  endpoints: build => {
    const functionsObject = {};
    for (const key in apiFunctions) {
      functionsObject[key] = build.query({
        query: params => ({
          apiMethod: apiFunctions[key],
          params,
        }),
        keepUnusedDataFor: 600,
        providesTags: () => [key],
      });
    }
    return functionsObject;
  },
});
